var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogoGooglePlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.158 11.463 2.09 22.01a2.73 2.73 0 0 0 3.999 1.62l11.328-6.452-5.26-5.716Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "m22.338 9.67-4.899-2.806-5.514 4.84 5.537 5.46 4.861-2.775a2.663 2.663 0 0 0 0-4.719h.015Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M2.09 1.996c-.06.225-.091.457-.09.69V21.32c0 .233.03.465.09.69l10.413-10.278L2.09 1.996Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "m12.233 12.003 5.206-5.139L6.126.383A2.79 2.79 0 0 0 4.723 0 2.73 2.73 0 0 0 2.09 1.988l10.143 10.015Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoGooglePlay);
export default __webpack_public_path__ + "static/media/ic_logo_google_play.b6657f292c24d6ba3b3deffcbcd1c6f0.svg";
export { ForwardRef as ReactComponent };